import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
    Button,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TableHeader,
    TableRow,
} from '@repo/shadcn';
import { BiTrash } from 'react-icons/bi';
import { TbRestore } from 'react-icons/tb';

import { CartListItem } from '@/features/slice/cart';

import { useCreateSale } from '../create-sale.hook';

export const ShowDraft = () => {
    const { allDrafts, draftLoading, draftError } = useCreateSale();

    if (draftError) {
        return <div>Error{draftError}</div>;
    }

    if (draftLoading) {
        return <div>Loading...</div>;
    }

    if (!allDrafts?.data.length) {
        return <div>No Drafts Found</div>;
    }

    return (
        <div className=" space-y-4">
            <h3 className="mb-4 text-xl font-semibold">Draft Details</h3>
            <Accordion type="single" collapsible className="w-full">
                {allDrafts?.data.map((draft) => (
                    <AccordionItem value={draft.id} key={draft.id}>
                        <AccordionTrigger>#{draft.draft_note}</AccordionTrigger>
                        <AccordionContent>
                            <ItemsListTable
                                draftItems={draft.items}
                                draftId={draft.id}
                            />
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
};

ShowDraft.displayName = 'ShowDraft';

const ItemsListTable = ({
    draftItems,
    draftId,
}: {
    draftItems: CartListItem[];
    draftId: string;
}) => {
    const { handleDraftToCart, draftToCartLoading } = useCreateSale();
    // const [total, setTotal] = useState(0);
    // useEffect(() => {
    //   const amount = draftItems.reduce(
    //     (p, c) => p + (c.total_price ? c.total_price : 0 * c.quantity),
    //     0,
    //   );
    //   setTotal(amount);

    // }, [total]);
    return (
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead className=" whitespace-nowrap">
                        Product
                    </TableHead>
                    <TableHead className="whitespace-nowrap text-right">
                        Amount
                    </TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {draftItems.map((item) => (
                    <TableRow key={item.id}>
                        <TableCell className="whitespace-nowrap font-medium">
                            {item.product_name}
                        </TableCell>
                        <TableCell className="whitespace-nowrap text-right">
                            {' '}
                            {item.quantity} * {item.price} =
                            {item.quantity * item.price}{' '}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
            <TableFooter className=" py-2">
                {/* <TableRow>
          <TableCell className=" text-[20px]">Total</TableCell>
          <TableCell className="text-right text-[20px]">
            {formatCurrencyInBTD(total)}
          </TableCell>
        </TableRow> */}

                <TableRow className="flex  w-full gap-4 py-2">
                    <Button
                        onClick={() => handleDraftToCart(draftId)}
                        type="button"
                        size="sm"
                        variant="secondary"
                    >
                        {draftToCartLoading ? (
                            'Loading...'
                        ) : (
                            <>
                                <TbRestore className="mr-1" /> Restore to Cart
                            </>
                        )}
                    </Button>
                    <Button type="button" size="sm" variant="destructive">
                        <BiTrash className="mr-1" /> Delete Forever
                    </Button>
                </TableRow>
            </TableFooter>
        </Table>
    );
};
